import {
  Box,
  Button,
  FormControl,
  Heading,
  HStack,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaGoogle } from "react-icons/fa";
import { useSignup } from "../../../hooks/useSignup.ts";
import Password from "../signIn/password.tsx";
import Email from "./Email.tsx";
import Fullname from "./Fullname.tsx";
import OTP from "./OTP.tsx";

const MAX_ATTEMPTS = 5;

const SignUp = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingOTPButton, setIsLoadingOTPButton] = useState(false);
  const [step, setStep] = useState(1);
  const [otpAttempts, setOtpAttempts] = useState(MAX_ATTEMPTS);
  const methods = useForm({
    defaultValues: {
      login: "",
      email: "",
      password: "",
      birthday: null,
      gender: "UNKNOWN",
      profilePhoto: null,
      otp: "",
      otpKey: "",
    },
  });



  const { submit, submitOTPStage } = useSignup(onClose);

  const updateOTPForm = (otpKey) => {
    setStep(2);
    methods.setValue("otpKey", otpKey);
  }

  const onSubmit = (data) => {
    submit(data, updateOTPForm);
    if (data.profilePhoto !== "") {
      setIsLoading(true);
    }
  };

  const onOTPSubmit = async (data) => {
    if  (otpAttempts === 0) {
      return ;
    }
    setIsLoadingOTPButton(true);

    try {
      await submitOTPStage(data);
    } catch (error) {
      const newAttempts = otpAttempts - 1;
      setOtpAttempts(newAttempts); // Decrease attempts on failure
      methods.setError("otp", {
        type: "manual",
        message: t(`Invalid OTP, please try again. You have ${otpAttempts - 1} attempt(s) left.`),
      });

      if (newAttempts === 0) {
        // Reset the signup process after 5 failed attempts
        setStep(1);
        setOtpAttempts(MAX_ATTEMPTS);
        methods.reset();
      }

      setIsLoadingOTPButton(false);
    }
  };


  const handleSocialLogin = (provider) => {
    // Implement social login logic here for the provider
    console.log(`Login with ${provider}`);
  };

  return (
      <FormProvider {...methods}>
        <VStack
            width="100%" // Same as SignIn for consistency
            justifyContent="center"
            p={{ base: "20px", md: "40px" }}
            spacing="20px"
            bg="#f7f8fc"
            borderRadius="10px"
            boxShadow="lg"
            maxW="500px"
            mx="auto"
            // my="10vh" // Centers the form vertically
        >
          <HStack justifyContent="space-between" w="100%">
            <Heading color="#111833" size="lg">
              {t("Sign Up")}
            </Heading>
          </HStack>

          {/*{step === 1 && (*/}
          {/*  <Box*/}
          {/*      w="100%"*/}
          {/*      display="flex"*/}
          {/*      flexDirection="column"*/}
          {/*      gap="15px"*/}
          {/*      alignItems="center"*/}
          {/*  >*/}
          {/*    <Button*/}
          {/*        leftIcon={<Icon as={FaGoogle} boxSize={5} />}*/}
          {/*        variant="outline"*/}
          {/*        width="100%"*/}
          {/*        onClick={() => handleSocialLogin("Google")}*/}
          {/*        colorScheme="red"*/}
          {/*        fontSize="14px"*/}
          {/*    >*/}
          {/*      {t("Sign up with Google")}*/}
          {/*    </Button>*/}
          {/*    /!* Uncomment these buttons if needed *!/*/}
          {/*    /!* <Button*/}
          {/*    leftIcon={<Icon as={FaFacebook} boxSize={5} />}*/}
          {/*    variant="outline"*/}
          {/*    width="100%"*/}
          {/*    onClick={() => handleSocialLogin("Facebook")}*/}
          {/*    colorScheme="facebook"*/}
          {/*    fontSize="14px"*/}
          {/*  >*/}
          {/*    {t("Sign up with Facebook")}*/}
          {/*  </Button> *!/*/}
          {/*    /!* <Button*/}
          {/*    leftIcon={<Icon as={FaApple} boxSize={5} />}*/}
          {/*    variant="outline"*/}
          {/*    width="100%"*/}
          {/*    onClick={() => handleSocialLogin("Apple")}*/}
          {/*    colorScheme="blackAlpha"*/}
          {/*    fontSize="14px"*/}
          {/*  >*/}
          {/*    {t("Sign up with Apple")}*/}
          {/*  </Button> *!/*/}
          {/*  </Box>*/}
          {/*)}*/}

          {/*{step === 1 && (*/}
          {/*<Text color="#707070" fontSize="14px">*/}
          {/*  {t("Or sign up with your email")}*/}
          {/*</Text>*/}
          {/*)}*/}
          {/*/!*<Divider mt={6} mb={4} w="100%" />*!/*/}


          <Box
              w="100%"
              bg="white"
              p={{ base: "20px", md: "30px" }}
              borderRadius="10px"
              boxShadow="md"
          >
            {step === 1 && (
            <FormControl
                as="form"
                onSubmit={methods.handleSubmit(onSubmit)}
                display="flex"
                flexDirection="column"
                gap="20px"
            >
              <Fullname />
              <Email />
              <Password />
              {/* Uncomment these fields if needed */}
              {/* <Box display="flex" flexDirection={{ base: "column", md: "row" }} gap="20px"> */}
              {/*   <Date /> */}
              {/*   <Gender /> */}
              {/* </Box> */}
              {/* <File /> */}
              <Button
                  mt="20px"
                  w="100%"
                  cursor="pointer"
                  _hover={{ bg: "#090632" }}
                  p="20px 0"
                  type="submit"
                  borderRadius="8px"
                  bg="#111833"
                  color="white"
                  fontSize="18px"
                  fontWeight="600"
                  isLoading={isLoading}
                  loadingText={t("Signing up...")}
              >
                  {t("Sign Up")}
              </Button>
            </FormControl>
            )}

            {/*-----------------------------------------------------*/}

            {step === 2 && (
            <FormControl
                as="form"
                onSubmit={methods.handleSubmit(onOTPSubmit)}
                display="flex"
                flexDirection="column"
                gap="20px"
            >
              <OTP />

              <Button
                  mt="20px"
                  w="100%"
                  cursor="pointer"
                  _hover={{ bg: "#090632" }}
                  p="20px 0"
                  type="submit"
                  borderRadius="8px"
                  bg="#111833"
                  color="white"
                  fontSize="18px"
                  fontWeight="600"
                  isLoading={isLoadingOTPButton}
                  loadingText={t("Signing up...")}
              >
                {t("Confirm")}
              </Button>
            </FormControl>
            )}


          </Box>
        </VStack>
      </FormProvider>
  );
};

export default SignUp;
